module.exports = __webpack_public_path__ + "img/3.ef818af7.png";